import { render, staticRenderFns } from "./newRegistering.vue?vue&type=template&id=24c19cb4"
import script from "./newRegistering.vue?vue&type=script&lang=js"
export * from "./newRegistering.vue?vue&type=script&lang=js"
import style0 from "./newRegistering.vue?vue&type=style&index=0&id=24c19cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports